import styled from '@emotion/styled';
import type { Ref, InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { colors } from '@/constants/colors';

interface CustomRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  isHovered?: boolean;
}

const RadioInput = styled.input<{ isHovered?: boolean }>`
  position: relative;
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: 2px solid ${colors.black200};
  appearance: none;
  background-color: ${colors.whiteGrey3};
  border-radius: 50%;
  cursor: pointer;
  ${({ isHovered }) =>
    isHovered && `border: 2px solid ${colors.black900};`}
  &:hover {
    border: 2px solid ${colors.black900};
  }
  &:checked {
    border: 1px solid ${colors.blue};
    background-color: ${colors.blue};
    ::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 12px;
      height: 12px;
      border: 2px solid ${colors.blue};
      background-color: ${colors.white};
      border-radius: 50%;
      content: '';
      transform: translate(-50%, -50%);
    }
  }
  &:disabled {
    opacity: 0.26;
  }
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  color: ${colors.dark};
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  gap: 8px;
  line-height: 24px;
  white-space: nowrap;
`;

const Radio = (
  { children, className, isHovered, ...property }: CustomRadioProps,
  forwardedRef: Ref<HTMLInputElement>,
) => (
  <RadioLabel className={className}>
    <RadioInput
      ref={forwardedRef}
      type="radio"
      isHovered={isHovered}
      {...property}
    />
    {children}
  </RadioLabel>
);

export default forwardRef(Radio);
